module.exports = __webpack_public_path__ + "static/Sleepless_MAR20_MRO_2073x1080[12363]-a1cb0e8921eee6b7ab236d85d0e78dbc.jpg";